package com.sweetlime.bingeamigo.presentation.features.xplog

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.XpLogEntry
import com.sweetlime.bingeamigo.repository.AuthRepository
import com.sweetlime.bingeamigo.repository.UserRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class XpLogViewModel(
    private val repository: UserRepository,
    private val authRepository: AuthRepository
) : ViewModel() {

    private val _entries = MutableStateFlow<List<XpLogEntry>>(emptyList())
    val entries = _entries.asStateFlow()

    private val _isLoading = MutableStateFlow(true)
    val isLoading = _isLoading.asStateFlow()

    fun load() {
        viewModelScope.launch {
            val uid = authRepository.currentUserId() ?: return@launch
            _entries.value = repository.getXpLog(uid)
                .filter { it.xp > 0 }
                .sortedByDescending { it.timestamp?.seconds ?: 0L }
            _isLoading.value = false
        }
    }
}